<template>
    <!-- 日期选择弹窗 -->
  <van-popup v-model="showDatePopup" class="date-popup" position="bottom">
    <div class="date-box">
            <div
                class="date-item"
                :class="{ active: curDateIndex == 0 }"
                @click="timeClick(0)"
            >
                {{ sDate | dateFormat("yyyy年MM月dd日") }}
            </div>
            <span>至</span>
            <div
                class="date-item"
                :class="{ active: curDateIndex == 1 }"
                @click="timeClick(1)"
            >
                {{ eDate | dateFormat("yyyy年MM月dd日") }}
            </div>
        </div>
            <div class="date-selectbox">
                <van-datetime-picker
                v-if="astrictToday"
                v-model="currentDate"
                type="date"
                title="选择年月日"
                :min-date="curDateIndex == 1 ? sDate : minDate"
                :visible-item-count="3"
                :max-date="curDateIndex == 0 ? eDate : maxDate"
                :show-toolbar="false"
                @change="dateChange"
                />
                <div class="btn-box">
                <div class="btn" @click="submit">确定</div>
                </div>
            </div>
  </van-popup>
</template>

<script>
export default {
    data(){
        return{
            showDatePopup: false, //时间选择面板
            sDate: new Date(),
            eDate: new Date(),
            minDate: new Date(2015,0,1),
            maxDate: new Date(),
            astrictToday:true,
            currentDate: new Date(),
            curDateIndex: 0,
        }
    },
    methods:{
        // 修改筛选时间
        dateChange() {
        if (this.curDateIndex == 0) {
            this.sDate = this.currentDate;
        } else {
            this.eDate = this.currentDate;
        }
        },
        // 提交数据
        submit() {
            console.log((this.eDate-this.sDate)/(60 * 60 * 24 * 1000));
            let time = (this.eDate-this.sDate)/(60 * 60 * 24 * 1000)
            if(time<367){
                this.showDatePopup = false;
                let sDate = this.$tools.dateFormat(this.sDate, "yyyy-MM-dd");
                let eDate = this.$tools.dateFormat(this.eDate, "yyyy-MM-dd");
                this.$emit("submit", [sDate, eDate]);
            } else{
                this.$notice.msg("选择时间不能超过366天")
            }
            
        },
        // 关闭
        close() {
        this.showDatePopup = false;
        },
        // 打开
        open(a,b) {
            this.sDate = new Date(a)
            this.eDate = new Date(b)
            this.showDatePopup = true;
            if (this.curDateIndex == 0) {
                this.currentDate = this.sDate;
            } else {
                this.currentDate = this.eDate;
            }
        },
        // 开始结束时间点击
        timeClick(i) {
            this.curDateIndex = i;
            this.astrictToday = false;
            this.$nextTick((_) => {
                this.astrictToday = true;
                this.currentDate = i == 0 ? this.sDate : this.eDate;
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@import "./showDatePopup.scss";
</style>